<template>
    <div ref="chart" class="pie-chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: "PieChart",
    props: {
        data: {
            type: Array,
            default: () => []
        },
        radius: {
            type: Array,
            default: () => ["30%", "60%"]
        },
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
        window.removeEventListener("resize", this.resizeChart);
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.updateChart();
            }
        }
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            this.setOption();
        },
        setOption() {
            const option = {
                tooltip: {
                    trigger: "item"
                },
                grid: {
                    top: 20,
                    bottom: 20,
                    left: 20,
                    containLabel: true
                },
               
                series: [
                    {
                        type: "pie",
                        radius: this.radius,
                        label: {
                            show: false,
                            position: "center"
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: "bold"
                            }
                        },
                        data: this.data
                    }
                ],
                dataZoom: [
                    {
                        type: "inside",
                        zoomOnMouseWheel: false, // 禁止滚轮缩放
                        moveOnMouseWheel: false, // 禁止滚轮平移
                        moveOnMouseMove: false,  // 禁止拖动
                        preventDefaultMouseMove: false,
                    },
                ],
            };
            this.chart.setOption(option);
        },
        updateChart() {
            if (this.chart) {
                this.setOption();
            }
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        }
    }
};
</script>

<style scoped>
.pie-chart {
    height: 35vh;
    width: 100%;
}
</style>
